import * as React from 'react';
import { Provider } from 'react-redux';
import createBrowserHistory from 'history/createBrowserHistory';
import { Router } from 'react-router';
import { createApplicationStore } from '@ui/store/store';

import Main from '../Main';

import './App.less';

const history = createBrowserHistory();
const store = createApplicationStore(history);

class App extends React.PureComponent {
  public render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <Main />
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.tsx